import { render, staticRenderFns } from "./DeviceRegistrationPage.vue?vue&type=template&id=fdb09494"
import script from "./DeviceRegistrationPage.vue?vue&type=script&lang=js"
export * from "./DeviceRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./DeviceRegistrationPage.vue?vue&type=style&index=0&id=fdb09494&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports